import { render, staticRenderFns } from "./DeleteClientModal.vue?vue&type=template&id=f8d1c8ac&scoped=true&"
import script from "./DeleteClientModal.vue?vue&type=script&lang=js&"
export * from "./DeleteClientModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteClientModal.vue?vue&type=style&index=0&id=f8d1c8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d1c8ac",
  null
  
)

export default component.exports